module.exports = __webpack_public_path__ + "static/media/Gallery_Grid_1-min.705c4fda.jpg";